import { useQuery } from "@apollo/client";
import { Layout, Space, Card, PageHeader, Empty } from "antd";

import { CreateProject } from "../../components/modal/CreateProject";
import { PROJECTS_QUERY } from "../../helpers/graphql/project";
import { ProjectCardItem } from "../../components/project/ProjectCardItem";

interface Project {
  id: string;
  name: string;
  identifier: string;
  createdAt: number;
  subgraphsCount: number;
  mainnetEndpointActive: boolean;
  mainnetArchiveEndpointActive: boolean;
  testnetEndpointActive: boolean;
  testnetArchiveEndpointActive: boolean;
}

export function Projects() {
  const { loading, data } = useQuery(PROJECTS_QUERY, { pollInterval: 5000 });

  const projects = data?.projects as Project[];

  return (
    <Layout className="content">
      <Layout.Header className="content-header">
        <PageHeader title="All Projects" className="page-title" extra={<CreateProject />} />
      </Layout.Header>
      <Layout.Content className="content-body">
        {loading ? (
          <Card loading={true} className="card-loading" />
        ) : (
          <Space direction="vertical" style={{ width: "100%" }}>
            {projects && projects.length > 0 ? (
              projects.map((project) => {
                return <ProjectCardItem project={project} key={project.id} />;
              })
            ) : (
              <Empty
                className="ant-empty-hero"
                description={
                  <span>Create your first project for deploying subgraphs and RPC endpoints</span>
                }
              >
                <CreateProject />
              </Empty>
            )}
          </Space>
        )}
      </Layout.Content>
    </Layout>
  );
}
